import { ChangeDetectionStrategy, Component, ElementRef, Input, ViewChild } from '@angular/core'
import { MovingImageService } from '../../../services/moving-image/moving-image.service'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { MiVideo } from '../../../services/moving-image/moving-image'
import { TextInput } from '../../types'
import { UcService } from '../../../enums/uc-service'
import { BehaviorSubject, combineLatest, of } from 'rxjs'
import { map, switchMap, tap } from 'rxjs/operators'

@Component({
  selector: 'mb-video-modal',
  templateUrl: './video-modal.component.html',
  styleUrls: ['./video-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoModalComponent {

  @ViewChild('playerContainer') playerContainer: ElementRef | undefined

  @Input() videoId: string | undefined
  @Input() containerId: string | undefined
  @Input() caption: TextInput | undefined
  @Input() description: TextInput | undefined
  @Input() video: MiVideo | undefined

  @Input() set id (id: string | undefined) {
    this.containerId = `video-container-${id}`
    this.videoId$.next(id)
  }

  videoId$ = new BehaviorSubject<string | undefined>('')

  video$ = this.videoId$.pipe(
    switchMap(videoId => videoId ? this.miService.getVideoById(videoId) : of(undefined)),
    tap(video => this.miService.createPlayerForVideo(this.containerId ?? '', video)))

  state$ = combineLatest([this.videoId$, this.video$]).pipe(
    map(([videoId, video]) => ({ videoId, video } as VideoModalState)))

  constructor (private miService: MovingImageService,
               private modal: NgbActiveModal) {
  }

  close () {
    this.modal.close()
  }

  readonly ucService = UcService
}

export interface VideoModalState {
  videoId: string | undefined;
  video: any;
}
